import { useState } from 'react'
import { Copy, RefreshCw } from 'lucide-react'
import Card from '../components/Card'
import Button from '../components/Button'

export default function TextReverser() {
  const [inputText, setInputText] = useState('')
  const [outputText, setOutputText] = useState('')
  const [reverseType, setReverseType] = useState('characters')

  const reverseText = (text, type) => {
    if (type === 'characters') {
      return text.split('').reverse().join('')
    } else if (type === 'words') {
      return text.split(' ').reverse().join(' ')
    } else if (type === 'lines') {
      return text.split('\n').reverse().join('\n')
    }
    return text
  }

  const handleReverse = () => {
    setOutputText(reverseText(inputText, reverseType))
  }

  const handleCopy = () => {
    navigator.clipboard.writeText(outputText)
    alert('Copied to clipboard!')
  }

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
            <div>
              <label className="label">Input Text:</label>
              <textarea
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                className="input h-32"
                placeholder="Enter your text here..."
              />
            </div>
            <div>
              <label className="label">Reversed Text:</label>
              <textarea
                value={outputText}
                readOnly
                className="input h-32"
                placeholder="Reversed text will appear here..."
              />
            </div>
          </div>

          <div className="mb-6">
            <label className="label">Reverse Type:</label>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {['characters', 'words', 'lines'].map((type) => (
                <label key={type} className="flex items-center cursor-pointer">
                  <input
                    type="radio"
                    name="reverse-type"
                    value={type}
                    checked={reverseType === type}
                    onChange={(e) => setReverseType(e.target.value)}
                    className="mr-2"
                  />
                  <span className="text-sm capitalize">{type}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="flex gap-4">
            <Button onClick={handleReverse} variant="primary">
              <RefreshCw className="w-4 h-4 mr-2" />
              Reverse
            </Button>
            <Button onClick={handleCopy} variant="secondary" disabled={!outputText}>
              <Copy className="w-4 h-4 mr-2" />
              Copy
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

